<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import en from "element-plus/lib/locale/lang/en";

// ElementPlus全局中文显示 localStorage.getItem(VUE_ADMIN_LANG_LOCALE) =="zh-CN"
const locale =
  localStorage.getItem("VUE_ADMIN_LANG_LOCALE") == "zh-CN" ? zhCn : en;

// 解决el-table 调整窗口报错
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};
</script>

<style lang="scss">
@import "@/style/mixin.scss";
@import url(../public/css/iconfont.css);
@import url(../public/css/index.css);
html,
body {
  @include bg_color();
  @include text_color();
}
#app {
  @include bg_color();
  @include text_color();
  height: 100%;
  padding: 0;
  margin: 0;
  // VR样式
  body div canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// 自定义进度条颜色
#nprogress .bar {
  background: #1156f8 !important;
}
</style>
